import {Permissions} from "./permissions";
import {BusinessType} from "../../enums/business-type";

/**
 * Created by maty on 13/02/2017.
 */

export class User {
    id: number = 0;
    email: string = "";
    first_name: string = "";
    last_name: string = "";
    country: string = "";
    company: string = "";
    business_type: BusinessType = BusinessType.Other;
    phone_prefix: string = "";
    password: string = "";
    phone_suffix: string = "";
    accepted_terms: boolean = false;
    poc: User;
    custom_id: string = "";
    default_markup = 0.0;
    permissions: Permissions = new Permissions();
    date_created: number = 0;
    date_changed: number = 0;
    blocked: boolean = false;
}



// WEBPACK FOOTER //
// ./src/app/entities/user/user.ts